export default __webpack_public_path__ + "static/media/image23.554a6c6a.jpg";